import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
 userRole: string = '';
  constructor() { }

  ngOnInit() {
     this.userRole = localStorage.getItem('userRole') || '';
    console.log('Logged User Role:', this.userRole);

  }

}



// WEBPACK FOOTER //
// ./src/app/common/header/header.component.ts